import axios from "axios";

export default {
  namespaced: true,
  state: () => ({
    loaded: false,
    clinicRegister: {
      az: false,
      de: true,
      en: false,
      ru: false,
      tr: false,
    },
    candidatesFilters: {
      profession: true,
      experience: true,
      language: true,
      certificate: true,
    },
    candidatesCard: {
      age: true,
      citizenship: true,
      experience: true,
      certificate: true,
      applied: true,
      specialties: true,
      languages: true,
    },
  }),
  getters: {
    canRegisterClinic: (state) => (lang) => {
      const key = (lang || "az").toLowerCase();
      return !!state.clinicRegister[key];
    },
    candidatesFilters: (state) => state.candidatesFilters,
    candidatesCard: (state) => state.candidatesCard,
  },
  mutations: {
    set(state, payload) {
      state.clinicRegister = {
        az: !!payload.clinicRegister_az,
        de: !!payload.clinicRegister_de,
        en: !!payload.clinicRegister_en,
        ru: !!payload.clinicRegister_ru,
        tr: !!payload.clinicRegister_tr,
      };
      // Yeni sahələr — server köhnə (sahə qaytarmadığı) hala gəlsə default true.
      state.candidatesFilters = {
        profession: payload.candidatesFilterProfession !== false,
        experience: payload.candidatesFilterExperience !== false,
        language: payload.candidatesFilterLanguage !== false,
        certificate: payload.candidatesFilterCertificate !== false,
      };
      state.candidatesCard = {
        age: payload.candidatesCardAge !== false,
        citizenship: payload.candidatesCardCitizenship !== false,
        experience: payload.candidatesCardExperience !== false,
        certificate: payload.candidatesCardCertificate !== false,
        applied: payload.candidatesCardApplied !== false,
        specialties: payload.candidatesCardSpecialties !== false,
        languages: payload.candidatesCardLanguages !== false,
      };
      state.loaded = true;
    },
  },
  actions: {
    async fetch({ commit }) {
      try {
        const res = await axios.get(`/featureSettings`);
        commit("set", res.data || {});
      } catch (e) {
        // tolerate failure — keep defaults
      }
    },
  },
};
